/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$("[data-action]").each(function () {
  $(this).on("click", () => {
    console.log($(this));
    setTimeout(function () {
      window.loyaltylion && window.loyaltylion.ui.refresh();
    }, 500);
  });
});

function announcementFunction() {
  $('[data-section-type="announcement-bar"]').each(function () {
    var index = 1;
    var parent = $(this);
    var time = parent.data("time");
    setInterval(function () {
      index++;

      if (
        parent.find('.AnnouncementBar__Content[data-index="' + index + '"]')
          .length == 0
      ) {
        index = 1;
      }

      parent
        .find('.AnnouncementBar__Content:not([data-index="' + index + '"])')
        .slideUp(300);
      parent
        .find('.AnnouncementBar__Content[data-index="' + index + '"]')
        .slideDown(300);
    }, time);
  });
}

$(document).ready(function () {
  announcementFunction();

  $(document).on("click", ".upsell-add", function () {
    
    var button = $(this);
    
    if($(this).hasClass('stage-select')){
      $(this).parents('.ProductItem').find('.direct-add-form').addClass('active');
    }
    else{
    var formId = $(this).data("form-id");

    console.log("upsell add clicked. FormId: #" + formId);
    var form = $("#" + formId);
      console.log(form.serialize());
    var actionUrl = form.attr("action");
    if (form.length == 1) {
      $.ajax({
        type: "POST",
        url: actionUrl,
        data: form.serialize(), // serializes the form's elements.
        success: function (data) {
          console.log("we made it!");
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1
              }
            })
          );

          if(button.data('variants-size') > 1){
          button.addClass('stage-select').html(button.data('select-text'));
          }
        }
      });
    }
    }
  });

  $(document).on("click", ".direct-add-radio", function(){
    var parent = $(this).parents('.ProductItem');
var button = parent.find('.upsell-add');
    button.removeClass('stage-select');
    button.html(button.data('add-text'));
  })

  $("[data-drawer-id=sidebar-cart][data-action=open-drawer]").click(function(){
    console.log('cart drawer should open');
  })

  $(document).mouseup(function(e) 
{
    var container = $(".direct-add-form");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.removeClass('active');
    }
});
});

document.addEventListener("theme:loading:end", function (event) {
  setTimeout(function () {
    window.loyaltylion && window.loyaltylion.ui.refresh();
  }, 500);
});
